import { RouteComponentProps } from 'react-router';
import * as RB from 'react-bootstrap';

import * as DTO from '../service/DTOs';
import * as API from '../service/apisvc';

import 'isomorphic-fetch';
import * as React from 'react';

import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { SecurityListItem } from './LookupListItems';
import * as TF from '../service/tradeflow';
import { Numeric } from '../components/input/Numeric'

import Cleave from 'cleave.js/react';
//var Cleave = require('cleave.js/react');


//import { NumberFormat } from 'react-number-format';



export interface NewOrderState {
    tradesession?: DTO.TradeSessionDto;
    instruments: DTO.InstrumentHead[],
    currencies: DTO.Currency[],
    durations: DTO.Duration[],
    form?: DTO.NewOrder;
    isSubmitting?: boolean;
    submitted?: boolean;
    result?: string;
    result_is_ok?: boolean;
    isLoading: boolean;
    seclookupoptions: any[];
    selectedSec?: DTO.Security;
}

type NewOrderProps = NewOrderState & { xsrfToken?: string }
    & {onNewOrderSubmitted?: (data: DTO.NewOrder) => {}}
    & { syshdr: DTO.SystemHeader };

const initialForm: DTO.NewOrder = {
    currency_id: 1,
    duration_id: 1,
    type: 'buy',
    rate: 0,
    discount: 0,
    sum: 0,
    minlot: 0,
    securityid: '',
    comment: ''
}

const initialState: NewOrderState = {
    //tradesession: { isopen: false, suspended: false, readonly: false },
    instruments: [],
    currencies: [],
    durations: [],
    form: initialForm,
    isSubmitting: false,
    submitted: false,
    isLoading: false,
    seclookupoptions: [],
    selectedSec: undefined
}

export class NewOrderComponent extends React.Component<NewOrderProps, NewOrderState> {    
    typeahead: any;

    constructor(props: NewOrderProps) {
        super(props);
        //this.state = { ...initialState, ...props };
        this.state = { ...initialState };
    }    

    componentWillReceiveProps(nextProps: NewOrderProps) {
        if (this.state.form !== nextProps.form && nextProps.form) {
            this.setState({ form: nextProps.form });
            //this.setState(nextProps)
        }
    }



    processNewOrderFromTemplate(data: DTO.NewOrder) {
        if (this.refs.cmpOrderEnranceRef) {
            if (this.state.form && data) {
                var _form = this.state.form;
                _form = data;                

                this.setState({ form: _form });

                //this.typeahead._handleInputChange(_form.securityid);

                this.getOptions(_form.securityid)
                    .then(({ options }) => {
                        let opts: any[] = options;
                        if (opts && opts.length == 1) {
                            this.typeahead._handleChange(opts);
                            //this.handleSecSelect(opts);
                        }
                    });
                

                //console.log(this.typeahead);
                //console.log(this.state);
                //if (this.state.seclookupoptions && this.state.seclookupoptions.length == 1) {
                //    this.handleSecSelect(this.state.seclookupoptions[0])
                //}
                //console.log(this.typeahead);

                ////this.typeahead.getInstance().

                //this.typeahead.setState({
                //    //activeIndex: -1,
                //    //activeItem: null,
                //    //initialItem: null,
                //    //shownResults: instance.props.maxResults,
                //    selected: [this.state.seclookupoptions[0]]
                //});
            }
        }

        return {};

    }

    componentDidMount() {
        TF.CommandProcessBinding(this, { type: 'COMMAND.NewOrderFromTemplate', delegate: this.processNewOrderFromTemplate });
    }

    handleTypeChange(eventKey: any) {
        if (this.state.form) {
            var _form = this.state.form;
            _form.type = eventKey;
            this.setState({ form: _form });
        }
    }

    handleCurrencySelect = (eventKey: any) => {
        if (this.state.form)
            this.setState({ form: { ...this.state.form, ...{ currency_id: eventKey} } });
    }

    handleDurationSelect = (eventKey: any) => {
        if (this.state.form)
            this.setState({ form: { ...this.state.form, ...{ duration_id: eventKey } } });
    }

    handleSecSelect = (sec: DTO.Security[]) => {

        if (this.state.form) {
            //console.log('handleSecSelect');
            if (sec && sec.length > 0)
                this.setState({ form: { ...this.state.form, ...{ securityid: sec[0].secid } }, selectedSec: sec[0] });
            else
                this.setState({ form: { ...this.state.form, ...{ securityid: '' } }, selectedSec: undefined });
        }

        //if (sec.length) {
        //    this.typeahead.getInstance().clear();
        //}

    }

    handleChange = (e: any) => {
        //console.log(e);
        if (this.state.form) {
            var _form = { ...this.state.form, ...e.target.hasOwnProperty('rawValue') ? { [e.target.name]: e.target.rawValue } : { [e.target.name]: e.target.value } };


            //this.setState({ [e.target.name]: e.target.value });
            if (Number(_form.minlot) > Number(_form.sum)) {
                _form.sum = _form.minlot;
            }

            this.setState({ form: _form });
        }
    }

    getOptions = (query: string) => {

        return fetch(API.apiUrl(API.API_SECLOOKUP_URL) + "/" + `${query}` + ".json", {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...
                {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': this.props.xsrfToken || ''
                },
                ...API.authHeader()
            })
        })
            .then((response) => {
                return response.json();
            }).then((json) => {
                return { options: json };
            });
    }

    _handleSecSearch = (query: string) => {
        this.setState({ isLoading: true });
        this.getOptions(query)
            .then(({ options }) => {
                //console.log("Lookup=");
                //console.log(options);
                this.setState({
                    isLoading: false,
                    seclookupoptions: options
                });
                //console.log(this.state);
            });
    }

    dispatch(action: NewOrderAction) {
        //console.log('dispatch');
        //console.log(action);
        this.setState(function (state, props) {
            return stateforwarder(state, action);
        });

        //this.setState({ ...this.state, ...stateforwarder(this.state, action) });
    }

    submitOrderForm = (form: DTO.NewOrder) =>  {

        return (async () => {
            this.dispatch({ type: 'SUBMIT_NEW_ORDER_FORM', payload: form });

            try {
                const xsrf = this.props.xsrfToken;
                //const formData = Object.entries(form).map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`).join('&');
                //const response: Response = await fetch(API.apiUrl(API.API_NEW_ORDER_URL), {
                //    method: 'POST',
                //    credentials: 'include',
                //    redirect: 'error',
                //    headers: new Headers({
                //        ...{
                //            'X-XSRF-TOKEN': xsrf || '',
                //            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
                //        },
                //        ...API.authHeader()
                //    }),
                //    body: formData
                //});


                const response: Response = await fetch(API.apiUrl(API.API_NEW_ORDER_URL), {
                    method: 'POST',
                    credentials: 'include',
                    headers: new Headers({
                        ...
                        {
                            'Content-Type': 'application/json',
                            'X-XSRF-TOKEN': xsrf || ''
                        },
                        ...API.authHeader()
                    }),
                    body: JSON.stringify(form)
                });

                //.catch(error => {
                //    console.error(error);
                //    //return { name: "network error", description: "" };
                //    return response;
                //    });

                const statusCode = response.status;
                if (statusCode === 201) {
                    const data = await response.json() as DTO.MessageDto<DTO.NewOrder>;
                    this.props.onNewOrderSubmitted ? this.props.onNewOrderSubmitted(data.result) : '';

                    this.dispatch({ type: 'NEW_ORDER_RECIEVED', payload: { form: data.result, result: 'Заявка создана успешно' } });

                    setTimeout(() => {
                        //this.dispatch(push('/'));
                        this.dispatch({ type: 'RESET_NEW_ORDER_FORM' });
                        this.typeahead.getInstance().clear();
                    }, 2000);
                }
                else if (statusCode === 422) {
                    let err = await response.json() as { newOrder4CreationDto: string[] };

                    this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, errors: err.newOrder4CreationDto, result: 'Введенные данные некорректны' } });
                }
                else {
                    let err = await response.json() as { newOrder4CreationDto: string[] };

                    this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, errors: err.newOrder4CreationDto, result: response.statusText } });
                }
            } catch (error) {
                //alert(error);
                this.dispatch({ type: 'NEW_ORDER_FORM_ERROR', payload: { form, errors: undefined, result: error.message || 'Произошла ошибка' } });
            }

        })();
    }

    submit = (event: React.FormEvent<RB.Form>) => {
        if (this.state.form) {
            this.submitOrderForm(this.state.form);
            event.preventDefault();
        }
    }

    setTypeaheadRef = (element: any) => {
        this.typeahead = element;
    };


    public render() {
        //debugger;
        if (this.state.form) {
            //let sIns = this.props.instruments.filter(ins => ins.fiid === (this.state.form ? this.state.form.fiid : ''));
            let sCur = this.props.currencies.filter(cur => cur.id === (this.state.form ? this.state.form.currency_id : 0));
            let sDur = this.props.durations.filter(dur => dur.id === (this.state.form ? this.state.form.duration_id : 0));

            let selectedSetFrm = this.state.selectedSec
                ? <div><b>{'Название:'}</b><br/>{this.state.selectedSec.name}
                    <div>
                        <b>SECID:</b>{this.state.selectedSec.secid}{' '}<b>ISIN:</b>{this.state.selectedSec.isin}
                    </div>
                </div>
                : <p className='rep_dimmedText' style={{ backgroundColor: 'white'}}>{"[Ценная бумага не определена]"}</p>;

            let buyCaption = this.state.isSubmitting ?
                <div><RB.Glyphicon glyph="glyphicon glyphicon-transfer" />{"Обработка"}</div>
                : this.state.form.type == 'buy' ? "Купить" : "Продать";


            let resultCap =                
                this.state.isSubmitting ?
                    <div>{"Отправка данных"}</div>
                    : this.state.submitted ?
                        (this.state.result_is_ok === undefined ? "" 
                            : this.state.result_is_ok ?
                                <div><RB.Glyphicon glyph="glyphicon glyphicon-ok" />{" "}{this.state.result}</div>
                                : <div><RB.Glyphicon glyph="glyphicon glyphicon-exclamation-sign" />{" "}{this.state.result}</div>
                        )
                        : "";

            let hdrContent = <div><b>Ввод новой заявки</b></div>
            //<legend className="text-center header">Ввод новой заявки</legend>


                //<NumberFormat.NumberFormat value={this.state.form.sum} thousandSeparator={true} onValueChange={(values: any) => {
                //    const { formattedValue, value } = values;
                //    if (this.state.form) {
                //        var _form = { ...this.state.form, ...{ sum: formattedValue } };
                //        this.setState({ form: _form });
                //    }
                //}} />

                //<RB.Col sm={7} smOffset={1}>
                //    <RB.DropdownButton
                //        bsStyle={"default".toLowerCase()}
                //        title={sIns != null ? sIns[0].name : "Инструмент"}
                //        key={"fiid"}
                //        name={"fiid"}
                //        id={"fiid"}
                //        onSelect={this.handleFiidSelect}
                //    >
                //        {this.props.instruments.map(ins =>
                //            <RB.MenuItem key={"mi_" + ins.fiid} value={ins.fiid} eventKey={ins.fiid} active={ins.fiid == (this.state.form ? this.state.form.fiid : '') ? true : false}>{ins.name}</RB.MenuItem>
                //        )}
                //    </RB.DropdownButton>
                //<Cleave. />
            //var v = Cleave;
            //console.log('Cleave');
            //console.log(v);


                //<Numeric num={this.state.form.sum} />
                //<NumberFormat value={2456981} displayType={'text'} thousandSeparator={true} prefix={'$'} />
            //<RB.FormControl name="sum" type="text" onChange={this.handleChange} value={this.state.form.sum} placeholder="sum" />
                //<RB.Well bsSize="sm" style={{ marginTop: '10px', maxHeight: '290px' }}>

            var wellTitleClass = 'rep_welltitle';
            let suspendCover = undefined;
            if (this.props.tradesession) {
                if (this.props.tradesession.readonly) {
                    wellTitleClass = wellTitleClass + ' readonly';
                    hdrContent = <div><b>Ввод новой заявки{' [ReadOnly]'}</b></div>
                }
                if (!this.props.tradesession.suspended && !this.props.tradesession.isopen) {
                    wellTitleClass = wellTitleClass + ' passive';
                }
                if (this.props.tradesession.suspended)
                    suspendCover = <div className='otc-coverdim'>
                        <span>Торги приостановлены</span>
                    </div>
            }
            else {
                wellTitleClass = wellTitleClass + ' passive';
            }


            return <div ref="cmpOrderEnranceRef">

                <RB.Row>
                    <RB.Col sm={12}>
                        <RB.Well bsSize="sm" style={{ marginTop: '10px', position: 'relative' }} >
                            {suspendCover}
                            <RB.ButtonToolbar className={wellTitleClass}>
                                <RB.ButtonGroup bsSize="xsmall">
                                    {hdrContent}
                                </RB.ButtonGroup>
                            </RB.ButtonToolbar>


                            <RB.Form horizontal method="post" onSubmit={this.submit} autoComplete="off" style={{ marginTop: '5px' }}>
                                <input type="hidden" name="requestVerificationToken" defaultValue={this.props.xsrfToken} />
                                <fieldset>
                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            <span className="align-bottom">{'Валюта/Срок:'}</span>
                                        </RB.Col>

                                        <RB.Col sm={7}>
                                            <RB.ButtonGroup>
                                            <RB.DropdownButton
                                                bsStyle={"default".toLowerCase()}
                                                title={sCur != null && sCur.length > 0 ? sCur[0].shortname : "Валюта"}
                                                key={"currency_id"}
                                                name={"currency_id"}
                                                id={"currency_id"}
                                                onSelect={this.handleCurrencySelect}
                                            >
                                                {this.props.currencies.map(cur =>
                                                    <RB.MenuItem key={"mi_cur_" + cur.id} value={cur.id} eventKey={cur.id} active={cur.id == (this.state.form ? this.state.form.currency_id : 0) ? true : false}>{cur.shortname}</RB.MenuItem>
                                                )}
                                                </RB.DropdownButton>
                                                <RB.Button style={{ minWidth: '5px', fontSize: '12px' }} disabled={true}>
                                                    {'/'}
                                                </RB.Button>

                                            <RB.DropdownButton
                                                bsStyle={"default".toLowerCase()}
                                                title={sDur != null && sDur.length > 0 ? sDur[0].name : "Срок"}
                                                key={"duration_id"}
                                                name={"duration_id"}
                                                id={"duration_id"}
                                                onSelect={this.handleDurationSelect}
                                            >
                                                {this.props.durations.map(dur =>
                                                    <RB.MenuItem key={"mi_dur_" + dur.id} value={dur.id} eventKey={dur.id} active={dur.id == (this.state.form ? this.state.form.duration_id : 0) ? true : false}>{dur.name}</RB.MenuItem>
                                                )}
                                                </RB.DropdownButton>
                                            </RB.ButtonGroup>
                                        </RB.Col>
                                    </RB.FormGroup>
                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            {'Направление:'}
                                        </RB.Col>
                                        <RB.Col sm={7}>

                                            <RB.ToggleButtonGroup
                                                type="radio"
                                                name="ordertype"
                                                id="ordertype"
                                                value={this.state.form.type}
                                                onChange={this.handleTypeChange}
                                            >
                                                <RB.ToggleButton value={"buy"} onClick={this.handleTypeChange.bind(this, 'buy')}>BUY</RB.ToggleButton>
                                                <RB.ToggleButton value={"sell"} onClick={this.handleTypeChange.bind(this, 'sell')}>SELL</RB.ToggleButton>
                                            </RB.ToggleButtonGroup>
                                        </RB.Col>
                                    </RB.FormGroup>

                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            {'Ставка/Дисконт:'}
                                        </RB.Col>

                                        <RB.Col sm={7}>
                                            <RB.InputGroup>
                                                <Cleave name="rate" className="form-control input-numeral" value={this.state.form.rate} placeholder="Ставка"
                                                    options={{ numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'none', numeralDecimalScale: 2, numeralIntegerScale: 2, numeralPositiveOnly: true }}
                                                    onChange={this.handleChange} />
                                                <RB.InputGroup.Addon style={{ minWidth: '5px', fontSize: '16px' }}>{'/'}</RB.InputGroup.Addon>
                                                <Cleave name="discount" className="form-control input-numeral" value={this.state.form.discount} placeholder="Дисконт"
                                                    options={{ numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'none', numeralDecimalScale: 2, numeralPositiveOnly: true, numeralIntegerScale: 2 }}

                                                    onChange={this.handleChange} />

                                                <RB.InputGroup.Addon>%</RB.InputGroup.Addon>
                                            </RB.InputGroup>                                            
                                        </RB.Col>
                                    </RB.FormGroup>

                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            {'Сумма/Мин.Лот:'}
                                        </RB.Col>

                                        <RB.Col sm={7}>
                                            <RB.InputGroup>
                                                <Cleave name="sum" className="form-control input-numeral" value={this.state.form.sum} placeholder="Сумма заявки"
                                                    options={{ numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'thousand', numeralDecimalScale: 0, numeralPositiveOnly: true }}
                                                    onChange={this.handleChange} />
                                                <RB.InputGroup.Addon style={{ minWidth: '5px', fontSize: '16px' }}>{'/'}</RB.InputGroup.Addon>
                                                <Cleave name="minlot" className="form-control input-numeral" value={this.state.form.minlot} placeholder="Мин. лот"
                                                    options={{ numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'thousand', numeralDecimalScale: 0, numeralPositiveOnly: true }}
                                                    onChange={this.handleChange} />
                                                <RB.InputGroup.Addon>{sCur && sCur.length > 0 ? sCur[0].shortname : '__'}</RB.InputGroup.Addon>
                                            </RB.InputGroup>
                                        </RB.Col>
                                    </RB.FormGroup>


                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            {'Комментарий:'}
                                        </RB.Col>

                                        <RB.Col sm={7}>
                                            <input type='text'
                                                value={this.state.form.comment}
                                                onChange={this.handleChange}
                                                className='form-control'
                                                id='comment'
                                                name='comment'
                                                placeholder='Комментарий'
                                                maxLength={200} />
                                        </RB.Col>
                                    </RB.FormGroup>

                                    <RB.FormGroup>
                                        <RB.Col sm={3} className='otc-inp-label'>
                                            {'Ценная бумага:'}
                                        </RB.Col>

                                        <RB.Col sm={7}>

                                            <AsyncTypeahead
                                                {...this.state}
                                                ref={this.setTypeaheadRef}
                                                //ref={( typeahead ) => this.typeahead = typeahead}
                                                clearButton={false}
                                                selected={this.state.selectedSec ? [this.state.selectedSec] : []}
                                                promptText="Введите строку для поиска"
                                                searchText="Поиск..."
                                                emptyLabel="Совпадений не найдено"
                                                paginationText="Еще результаты..."
                                                //highlightOnlyResult={true}
                                                labelKey="secid"
                                                minLength={2}
                                                maxResults={50}
                                                onSearch={this._handleSecSearch}
                                                placeholder="Поиск тикера"
                                                align="right"
                                                filterBy={['isin', 'name', 'secid', 'shortname']}

                                                renderMenuItemChildren={(sec, props, idx) => (
                                                    <SecurityListItem key={'seclistitem_' + idx} sec={sec} />
                                                )}
                                                onChange={this.handleSecSelect}
                                                options={this.state.seclookupoptions}                                                
                                            />
                                        </RB.Col>
                                    </RB.FormGroup>

                                    <RB.FormGroup >

                                        <RB.Col sm={7}>
                                            {selectedSetFrm}
                                        </RB.Col>

                                        <RB.Col sm={3} className="text-center">
                                            {this.props.tradesession && this.props.tradesession.isopen ?
                                                <RB.Button style={{ float: 'right' }} type="submit" bsSize="sm" bsStyle="primary" disabled={this.state.isSubmitting || !this.state.selectedSec}>{buyCaption}</RB.Button>
                                                : undefined
                                            }
                                        </RB.Col>
                                    </RB.FormGroup>
                                    <hr />
                                    <RB.FormGroup>
                                        <RB.Col sm={12} className="text-center">
                                            
                                            <div>
                                                {resultCap}
                                            </div>
                                        </RB.Col>
                                    </RB.FormGroup>

                                </fieldset>
                            </RB.Form>
                        </RB.Well>
                    </RB.Col>
                </RB.Row>
            </div>
        }
        else
            return <p><em>Loading...</em></p>;
    }
}


interface SubmitNewOrderFormAction {
    type: 'SUBMIT_NEW_ORDER_FORM'
    payload: DTO.NewOrder
}

interface NewOrderFormRecievedAction {
    type: 'NEW_ORDER_RECIEVED',
    payload: {
        form: DTO.NewOrder;
        result: string;
    }
}

interface ResetNewOrderFormAction {
    type: 'RESET_NEW_ORDER_FORM'
}


interface NewOrderFormErrorAction {
    type: 'NEW_ORDER_FORM_ERROR',
    payload: {
        form: DTO.NewOrder,
        errors: string[] | undefined,
        result: string;
    }
}

type NewOrderAction = SubmitNewOrderFormAction | NewOrderFormRecievedAction | ResetNewOrderFormAction | NewOrderFormErrorAction;


const stateforwarder = (state: NewOrderState, action: NewOrderAction) => {
    switch (action.type) {
        case 'SUBMIT_NEW_ORDER_FORM':
            console.log('do SUBMIT_NEW_ORDER_FORM');
            return {
                form: action.payload,
                isSubmitting: true,
                submitted: false,
                result_is_ok: undefined
            };
        case 'NEW_ORDER_RECIEVED':
            console.log('do NEW_ORDER_RECIEVED');
            return {
                //form: initialForm,
                isSubmitting: true,
                submitted: true,
                result_is_ok: true,
                result: action.payload.result
            };
        case 'NEW_ORDER_FORM_ERROR':
            return {
                form: action.payload.form,
                isSubmitting: false,
                submitted: true,
                result_is_ok: false,
                result: action.payload.errors ? (action.payload.errors.length > 0 ? action.payload.errors[0] : action.payload.result) : action.payload.result                
            };
        case 'RESET_NEW_ORDER_FORM':
            console.log('do RESET_NEW_ORDER_FORM');
            return {
                form: initialForm,
                isSubmitting: false,
                submitted: false,
                result: '',
                //seclookupoptions: [],
                selectedSec: undefined,
                result_is_ok: undefined
            };
        default:
        const exhaustiveCheck: never = action;
    }

    return state;
};


